import React, { useState, useEffect, useRef } from 'react'
// import { CSVLink } from "react-csv"

// import Sidebar from 'components/Sidebar'
// import Card from 'components/Card'

// import FilterItem from 'components/FilterItem'
import Location, { LocationContainer } from 'components/Location2'

// import  Toggle from 'components/Toggle'
// import Expander from 'components/Expander'

// import { camelCase } from 'lodash'

import { icon } from 'functions'
import { useQuery } from '@apollo/react-hooks'
import { GET_MAP_PINS } from 'operations/Location'

import './map.scss'
import Search from './Search'
// import { nanoid } from 'nanoid'

// import { DateTime } from 'luxon'

import { useJsApiLoader, GoogleMap } from '@react-google-maps/api'
import Loader from 'components/Loader'
// import GetTravelTime from 'components/GetTravelTime'
import TravelTimeDisplay from 'components/TravelTimeDisplay'
import { polygonStyles } from 'config'

// import MarkerClusterer from '@googlemaps/markerclustererplus'

// let utf8decoder = new TextDecoder();

// const google = window.google

const libraries = ['geometry', 'drawing', 'places']

export default function MapView({ region, provinceCode, clearProvinceCode, center: initialCenter, zoom: initialZoom }) {

    // Load google maps script
    const { isLoaded, loadError } = useJsApiLoader({
        // googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        googleMapsApiKey:"AIzaSyDTheEdmTowW9Zq0aZg4yGxRs3PtMg2Mvw",
        // mapIds: ['df761b567ea1ab68'],
        libraries: libraries
    })

    const { data } = useQuery(GET_MAP_PINS, {
        variables: {
            limit: 50000,
            provinceCode
        }
    })

    const { mapPins: locations } = data || {}
    
    const [theme, setTheme] = useState('dark')

    const [ map, setMap ] = useState(null)
    const [ markers, setMarkers ] = useState()
    const [ currentMarkerId, setCurrentMarkerId ] = useState()
    const [ pin, setPin ] = useState()
    const [ pinMarker, setPinMarker ] = useState()
    
    const [ filters, setFilters ] = useState()

    const [ travelTime, setTravelTime ] = useState()
    const [ isocrones, setIsocrones ] = useState()
    const [ distance, setDistance ] = useState()
    const [ radius, setRadius ] = useState()

    const [ exportLocations, setExportLocations ] = useState()

    // Google Maps Load and Unload
    const onLoad = React.useCallback(function callback(map) {
        setMap(map)
    }, [])
    const onUnmount = React.useCallback(function callback() {
        setMap(null)
    }, [])

    // Build markers
    useEffect(() => {

        if (locations) {

            const google = window.google

            const mapMarkers = []
            locations.map((pin, i) => {

                const marker = new google.maps.Marker({
                    position: { lat: pin.lat || pin.latitude, lng: pin.lng || pin.longitude },
                    map,
                    icon: icon(pin),
                    title: pin.companyName,
                    ...(pin.googlePlaceId && {
                        place: {
                            placeId: pin.googlePlaceId,
                            location: { lat: parseFloat(pin.lat || pin.latitude), lng: parseFloat(pin.lng || pin.longitude) }
                        }
                    })                    
                })

                // Marker click function
                google.maps.event.addListener(marker, 'click', (event) => {
                    setCurrentMarkerId(i)
                })

                return mapMarkers.push(marker)
            })
            setMarkers(mapMarkers)
        }

    }, [locations, map])

    // Build filter list
    useEffect(() => {
        // Create unique filters
        if (locations && !filters) {
            const filters = []
            locations.map(location => {
                if (!filters[location.channelSegment]) {
                    filters[location.channelSegment] = {
                        isVisible: true,
                        totalLocations: 0,
                        visibleLocations: 0,
                        mapTypes: []
                    }
                }

                // Count markers in each channel segment
                filters[location.channelSegment].totalLocations++

                // If not exists, add mapType as a child of channelSegment
                if (!filters[location.channelSegment].mapTypes.includes(location.mapType)) {
                    filters[location.channelSegment].mapTypes.push(location.mapType)   
                }
                return null
            })
            setFilters(filters)
        }
    }, [filters, locations])

    useEffect(() => {
        if (filters) {
            locations.map((location, locationKey) => {
                const isVisible = filters[location.channelSegment].isVisible
                return markers[locationKey].setMap(isVisible ? map : null)
            })
        }
        // eslint-disable-next-line
    }, [filters])

    const prevMarkerRef = useRef()
    useEffect(() => {
        if (currentMarkerId) {

            const google = window.google
            const marker = markers[currentMarkerId]
            map.panTo(marker.getPosition())
            map.setZoom(14)
            marker.setIcon(icon(locations[currentMarkerId], 'lg'))
            marker.setAnimation(google.maps.Animation.BOUNCE)
            setTimeout(() => {
                marker.setAnimation(null)
            }, 3750);

            // Clear a previously selected marker
            if (prevMarkerRef.current) {
                const previousMarker = markers[prevMarkerRef.current]
                previousMarker.setIcon(icon(locations[prevMarkerRef.current], 'sm'))
                previousMarker.setAnimation(null)
            }
            prevMarkerRef.current = currentMarkerId

            if (pinMarker) {
                pinMarker.setMap(null)
                setPinMarker()
                setPin()
            }

        }
        // eslint-disable-next-line
    }, [currentMarkerId])

    useEffect(() => {

        if (isocrones && isocrones.length > 0) {

            const google = window.google

            const exportLocations = []

            markers.map((marker, markerKey) => {
                return isocrones.map(isocrone => {
                    if (google.maps.geometry.poly.containsLocation(markers[markerKey].getPosition(), isocrone)) {
                        return exportLocations.push(locations[markerKey].id)
                    }
                    return null
                })
            })

            setExportLocations(exportLocations)
        }

    },[isocrones, markers, locations])

    useEffect(() => {

        if (radius) {

            // const google = window.google

            const exportLocations = []

            const bounds = radius.getBounds()

            markers.map((marker, markerKey) => {

                if (bounds.contains(markers[markerKey].getPosition()) === true) {
                    return exportLocations.push(locations[markerKey].id)
                }
                return null
            })

            setExportLocations(exportLocations)
        }

    },[radius, markers, locations])
    

    const filterViewportMarkers = () => {
        if (markers) {
            for (let i = 0; i < markers.length; i++) {
                if (map.getBounds().contains(markers[i].getPosition())) {
                    const isVisible = filters[locations[i].channelSegment].isVisible
                    if (isVisible) {
                        markers[i].setMap(map)
                    }
                    else {
                        markers[i].setMap(null)
                    }
                }
                else {
                    // Hide markers outside viewport
                    // Do not hide current marker
                    if (currentMarkerId === i) {} else {
                        markers[i].setMap(null)
                    }
                }
            }
        }
    }

    const renderMap = () => {

        // const google = window.google       

        return (
            <div className='map__container'>
                <GoogleMap
                    key={theme}
                    mapContainerStyle={{
                        width: '100%',
                        height: '100%'
                    }}
                    center={ initialCenter }
                    zoom={ initialZoom }
                    options={{

                        mapTypeControl: false,
                        // mapTypeControlOptions: {
                        //     style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                        //     position: google.maps.ControlPosition.TOP_RIGHT
                        // },
                        zoomControl: false,
                        // zoomControlOptions: {
                        //     position: google.maps.ControlPosition.RIGHT_BOTTOM
                        // },
                        scaleControl: false,
                        // streetViewControl: true,
                        // streetViewControlOptions: {
                        //     position: google.maps.ControlPosition.RIGHT_CENTER
                        // },
                        streetViewControl: false,
                        fullscreenControl: false,
                        gestureHandling: 'greedy',
                        mapId: theme === 'dark' ? 'df761b567ea1ab68' : 'c7a022a25cb50316e8eb6342'  // LIGHT,
                        // mapId: 'df761b567ea1ab68' // Dark
                        
                        // LIGHT '63fc840dc815325347c4f1d3'
                        // LIGHT - MONOCHROME '63fc840dc81532533e94ac6e'
                        // DARK 'df761b567ea1ab68'
                    }}
                    onLoad={ onLoad }
                    onUnmount={ onUnmount }
                    onIdle={() => {
                        filterViewportMarkers()
                    }}
                >
                    
                </GoogleMap>
                
                <Search
                    filters={ filters }
                    onChange={(id) => {
                        const i = data.mapPins.findIndex(x => x.id === id)
                        setCurrentMarkerId(i)
                    }} 
                    onSetGeometry={ geometry => {
                        const google = window.google

                        const marker = new google.maps.Marker({
                            position: { lat: geometry.location.lat, lng: geometry.location.lng },
                            map                  
                        })

                        if (pinMarker) pinMarker.setMap(null)

                        map.panTo({ lat: geometry.location.lat, lng: geometry.location.lng })
                        map.setZoom(14)
                        if (prevMarkerRef.current) {
                            const previousMarker = markers[prevMarkerRef.current]
                            previousMarker.setIcon(icon(locations[prevMarkerRef.current], 'sm'))
                            previousMarker.setAnimation(null)
                        }
                        setCurrentMarkerId()
                        setPin(geometry)
                        setPinMarker(marker)

                    }}
                    onChangeFilter={({ key, state }) => {
                        setFilters(filters => {
                            return ({
                                ...filters,
                                [key]: {
                                    ...filters[key],
                                    isVisible: state
                                }
                            })
                        })
                    }}
                    provinceCode={ provinceCode }
                    clearProvinceCode={ clearProvinceCode }
                    theme={theme}
                    changeTheme={() => setTheme(theme === 'dark' ? 'light':'dark')}
                />
                {
                    !markers && (
                        <Loader />
                    )
                }
                {
                    pin && <LocationContainer
                        pin={ pin }
                        map={ map }
                        onFetchTravelTime={(data) => {
                            const google = window.google

                            isocrones && isocrones.map(isocrone => {
                                return isocrone.setMap(null)
                            })

                            const newIsocrones = []

                            data.result.geometry.coordinates.map((coords) => {

                                const shape = {}

                                coords.map((polygon, i) => {

                                    const newShape = []
                                    polygon.map(coords => newShape.push({ lat: coords[1], lng: coords[0] }))

                                    if (i < 1) shape.shell = newShape
                                    if (i === 1) shape.holes = []
                                    if (i > 0) {
                                        shape.holes.push(newShape)
                                    }
                                    return null
                                })

                                const isocrone = new google.maps.Polygon({
                                    // paths: shape.holes ? [shape.shell, ...shape.holes] : shape.shell,
                                    paths: shape.shell,
                                ...polygonStyles
                                })
                                isocrone.setMap(map)
                                return newIsocrones.push(isocrone)
                            })
                            setIsocrones(newIsocrones)
                            setTravelTime(data.travelTime)
                        }}
                    />
                }                
                {
                    currentMarkerId && (
                        <Location locationId={ locations[currentMarkerId].id } map={ map } onFetchTravelTime={(data) => {
                            const google = window.google

                            if (data.error) {
                                console.log(data.result)
                                return alert(`Error: ${ data.result }. Please use the distance option instead.`)
                            }

                            isocrones && isocrones.map(isocrone => {
                                return isocrone.setMap(null)
                            })

                            const newIsocrones = []

                            data.result.geometry.coordinates.map((coords) => {

                                const shape = {}

                                coords.map((polygon, i) => {

                                    const newShape = []
                                    polygon.map(coords => newShape.push({ lat: coords[1], lng: coords[0] }))

                                    if (i < 1) shape.shell = newShape
                                    if (i === 1) shape.holes = []
                                    if (i > 0) {
                                        shape.holes.push(newShape)
                                    }
                                    return null
                                })

                                const isocrone = new google.maps.Polygon({
                                    // paths: shape.holes ? [shape.shell, ...shape.holes] : shape.shell,
                                    paths: shape.shell,
                                ...polygonStyles
                                })
                                isocrone.setMap(map)
                                return newIsocrones.push(isocrone)
                            })

                            if (radius) radius.setMap(null)
                            setRadius()
                            setDistance()

                            setIsocrones(newIsocrones)
                            setTravelTime(data.travelTime)
                        }}
                        
                        onFetchCircle={({ result, distance }) => {

                            if (radius) radius.setMap(null)
                            isocrones && isocrones.map(isocrone => {
                                return isocrone.setMap(null)
                            })
                            setIsocrones()
                            setTravelTime()

                            setRadius(result)
                            setDistance(distance)
                        }}
                        />
                    )
                }
                {
                    travelTime && <TravelTimeDisplay type='TIME' isocrones={isocrones} map={map} exportLocations={ exportLocations } onClose={() => {
                        isocrones.map(isocrone => isocrone.setMap(null))
                        setTravelTime()
                        return setExportLocations()
                    }}>{ travelTime }</TravelTimeDisplay>
                }
                {
                    distance && <TravelTimeDisplay type='DISTANCE' radius={ radius } map={ map } exportLocations={ exportLocations } onClose={() => {
                        radius.setMap(null)
                        setDistance()
                        return setExportLocations()
                    }}>{ distance }</TravelTimeDisplay>
                }
            </div>
        )

    }

    if (loadError) return `Failed to load map: ${loadError}`

    return isLoaded ? renderMap() : null
}

    // Set after initMap completes
    // const [ mapLoaded, setMapLoaded ] = useState(false)

    // let map = {}
    // const [ markers, setMarkers ] = useState([])
    // const [ selectedMarker, setSelectedMarker ] = useState()
    // const [ travelTimeBounds, setTravelTimeBounds ] = useState()
    // const [ exportLocations, setExportLocations ] = useState([])
    // const [ channelSegments, setChannelSegments ] = useState([])
    // const [ boundsDistance, setBoundsDistance ] = useState(25)
    // const [ zoom ] = useState(initialZoom)
    // const [ isocrones, setIsocrones ] = useState([])

    // const [ center, ] = useState(initialCenter)

    // const [ getMapPins, {  data } ] = useLazyQuery(GET_MAP_PINS)
    // const [ getTravelTime, { data: travelTimeData } ] = useLazyQuery(GET_TRAVELTIME)
    // const [ getTravelTime2, { data: travelTimeData2 } ] = useLazyQuery(GET_TRAVELTIME2)

    // const { mapPins } = data || { mapPins: [] }

//     const [ mapPins, setMapPins ] = useState([])

//     useEffect(() => {

//         loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyDTheEdmTowW9Zq0aZg4yGxRs3PtMg2Mvw&map_ids=df761b567ea1ab68&callback=initMap&libraries=geometry,drawing,places")

//         window.initMap = initMap
//         // eslint-disable-next-line
//     }, [])

//     useEffect(() => {

//         if (mapLoaded) {
//             getMapPins({ variables: { limit: 50000 } })
//         }

//     }, [mapLoaded, getMapPins])

//     useEffect(() => {
//         if (data) {
//             const { mapPins } = data
//             setMapPins(mapPins)
//         }
//     }, [data])

//     useEffect(() => {
//         if (selectedMarker) {
//             getNearbyLocations()
//         }
//         // eslint-disable-next-line
//     }, [boundsDistance, channelSegments])

//     useEffect(() => {
//         if (mapPins.length > 0) {

//             const google = window.google

//             const newMarkers = []
//             const channelSegments = {}
//             mapPins.map((pin, i) => {
//                 // console.log(pin.latitude)
//                 // Create a marker for every mapPin
//                 const marker = new google.maps.Marker({
//                     position: { lat: pin.lat || pin.latitude, lng: pin.lng || pin.longitude },
//                     map,
//                     icon: icon(pin),
//                     title: pin.companyName,
//                     ...(pin.googlePlaceId && {
//                         place: {
//                             placeId: pin.googlePlaceId,
//                             location: { lat: parseFloat(pin.lat || pin.latitude), lng: parseFloat(pin.lng || pin.longitude) }
//                         }
//                     })                    
//                 })

//                 // Create unique channelSegmens
//                 if (!channelSegments[pin.channelSegment]) {
//                     channelSegments[pin.channelSegment] = {
//                         isVisible: true,
//                         totalLocations: 0,
//                         visibleLocations: 0,
//                         mapTypes: []
//                     }
//                 }

//                 // Count markers in each channel segment
//                 channelSegments[pin.channelSegment].totalLocations++

//                 // If not exists, add mapType as a child of channelSegment
//                 if (!channelSegments[pin.channelSegment].mapTypes.includes(pin.mapType)) {
//                     channelSegments[pin.channelSegment].mapTypes.push(pin.mapType)   
//                 }

//                 // Marker click function
//                 google.maps.event.addListener(marker, 'click', (event) => {

//                     // Bring clicked marker into focus
//                     marker.setIcon(icon(pin, 'lg'))
//                     marker.setAnimation(google.maps.Animation.BOUNCE)
//                     setTimeout(() => {
//                         marker.setAnimation(null)
//                     }, 3750);

//                     setSelectedMarker(i)

//                     // Clear any previously selected travelTimeBounds
//                     clearTravelTimeBounds()

//                 })

//                 return newMarkers.push(marker)

//             })

//             // const markerClusterer = new MarkerClusterer(map, newMarkers)

//             // console.log(markerClusterer)

//             setMarkers(newMarkers)
//             setChannelSegments(channelSegments)

//         }
//         // eslint-disable-next-line
//     }, [mapPins])

//     const prevMarkerRef = useRef()

//     useEffect(() => {
//         if (selectedMarker) {

//             const google = window.google
//             const marker = markers[selectedMarker]
//             map.panTo(marker.getPosition())
//             map.setZoom(14)
//             marker.setIcon(icon(mapPins[selectedMarker], 'lg'))
//             marker.setAnimation(google.maps.Animation.BOUNCE)
//             setTimeout(() => {
//                 marker.setAnimation(null)
//             }, 3750);
//             // console.log('SET MARKER-------', mapPins[selectedMarker])

//             // Clear a previously selected marker
//             if (prevMarkerRef.current) {
//                 const previousMarker = markers[prevMarkerRef.current]
//                 previousMarker.setIcon(icon(mapPins[prevMarkerRef.current], 'sm'))
//                 previousMarker.setAnimation(null)
//             }
//             prevMarkerRef.current = selectedMarker
//         }
//         // eslint-disable-next-line
//     }, [selectedMarker])

//     // GET TRAVELTIME
//     useEffect(() => {

//         if (selectedMarker) {

//             const now = DateTime.local().setZone('UTC').toISO()

//             const marker = mapPins[selectedMarker]

//             getTravelTime({
//                 variables: {
//                     payload: {
//                         departure_searches: {
//                             id: nanoid(),
//                             coords: {
//                                 lat: marker.latitude,
//                                 lng: marker.longitude
//                             },
//                             transportation: {
//                                 type: 'driving'
//                             },
//                             departure_time: now,
//                             travel_time: 3600
//                         }
//                     }
//                 }
//             })

//             getTravelTime2({
//                 variables: {
//                     payload: {
//                         origin: {
//                             lat: marker.latitude,
//                             lng: marker.longitude
//                         },
//                         mode: 'drive',
//                         time: 3600,
//                         congestion: false
//                     }
//                 }
//             })

//         }

//     }, [selectedMarker])

//     useEffect(() => {
//         if (travelTimeData && travelTimeData.travelTime && travelTimeData.travelTime.results) {

//             const google = window.google

//             travelTimeData.travelTime.results.map(result => {

//                 result.shapes.map(shape => {
//                     const isocrone = new google.maps.Polygon({
//                         paths: shape.holes.length > 1 ? [shape.shell, ...shape.holes] : shape.shell,
//                         // paths: shape.shell,
//                         strokeColor: "#FFC107",
//                         strokeOpacity: 0.8,
//                         strokeWeight: 2,
//                         fillColor: "#FFC107",
//                         fillOpacity: 0.35,
//                     })
//                     isocrone.setMap(map)
//                 })
//             })

//         }
//     }, [travelTimeData])

//     useEffect(() => {
//         if (travelTimeData2 && travelTimeData2.travelTime2 && travelTimeData2.travelTime2.geometry) {

//             const google = window.google

//             const isocrones = []

//             travelTimeData2.travelTime2.geometry.coordinates.map((coords) => {

//                 const shape = {}

//                 coords.map((polygon, i) => {

//                     const newShape = []
//                     polygon.map(coords => newShape.push({ lat: coords[1], lng: coords[0] }))

//                     if (i < 1) shape.shell = newShape
//                     if (i === 1) shape.holes = []
//                     if (i > 0) {
//                         shape.holes.push(newShape)
//                     }
//                 })

//                 const isocrone = new google.maps.Polygon({
//                     // paths: shape.holes ? [shape.shell, ...shape.holes] : shape.shell,
//                     paths: shape.shell,
//                     strokeColor: "#FFCCCC",
//                     strokeOpacity: 0.8,
//                     strokeWeight: 2,
//                     fillColor: "#FFCCCC",
//                     fillOpacity: 0.35,
//                 })
//                 isocrone.setMap(map)
//                 return isocrones.push(isocrone)
//             })
//             setIsocrones(isocrones)

//         }
//     }, [travelTimeData2, map])

//     useEffect(() => {
//         if (isocrones && isocrones.length > 0) {
//             const google = window.google
//             const exportLocations = []
//             // Reset all channelSegment visibleLocations count to 0
//             Object.keys(channelSegments).map((channelSegment) => {
//                 return channelSegments[channelSegment].visibleLocations = 0
//             })
//             for (let i = 0; i < isocrones.length; i++) {
//                 for( let ii = 0; ii < markers.length; ii++) {
//                     if (google.maps.geometry.poly.containsLocation(markers[ii].getPosition(), isocrones[i])) {
//                         console.log('INSIDE POLY')
//                         console.log(markers[i])
//                         const location = mapPins[ii]
//                         if (channelSegments[location.channelSegment].isVisible) {
//                             channelSegments[location.channelSegment].visibleLocations++   
//                             exportLocations.push(location.id)
//                         }
//                     }
//                     else {
//                         // Can optionally set markers outside the bounds to a different color
//                         markers[ii].setIcon(icon({channelSegment: 'grey'}))
//                     }
//                 }
//             }
//             setExportLocations(exportLocations)
//             setChannelSegments(channelSegments)
//         }
//     }, [isocrones, markers])

//     const prevTravelTimeBoundsRef = useRef()
//     useEffect(() => {
//         if (travelTimeBounds) {
//             if (prevTravelTimeBoundsRef.current) {
//                 prevTravelTimeBoundsRef.current.setMap(null)
//             }
//             prevTravelTimeBoundsRef.current = travelTimeBounds
//         }
//     }, [travelTimeBounds])

//     function initMap() {

//         const google = window.google

//         const map = new google.maps.Map(document.getElementById('map'), {
//             center: { lat: center.latitude, lng: center.longitude },
//             zoom,
//             mapTypeControl: true,
//             mapTypeControlOptions: {
//                 style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
//                 position: google.maps.ControlPosition.TOP_RIGHT
//             },
//             zoomControl: true,
//             zoomControlOptions: {
//                 position: google.maps.ControlPosition.RIGHT_BOTTOM
//             },
//             scaleControl: true,
//             streetViewControl: true,
//             streetViewControlOptions: {
//                 position: google.maps.ControlPosition.RIGHT_CENTER
//             },
//             fullscreenControl: false,
//             gestureHandling: 'greedy',
//             mapId: 'df761b567ea1ab68'
//         })

//         setMap(map)
//         setMapLoaded(true)

//     }

//     // const prevTravelTimeBoundsRef = useRef()
//     function clearTravelTimeBounds() {
//         setTravelTimeBounds()
//         setExportLocations([])
//     }

//     function changeBoundsDistance(boundsDistance) {
//         setBoundsDistance(boundsDistance)
//     }

//     // Create travelTimeBounds and filter markers
//     function getNearbyLocations() {

//         // Clear any previous travelTimeBounds
//         clearTravelTimeBounds()

//         const google = window.google

//         const marker = markers[selectedMarker]

//         const travelTimeBounds = new google.maps.Circle({
//             strokeColor: '#FF0000',
//             strokeOpacity: 0.8,
//             strokeWeight: 2,
//             fillColor: '#FF0000',
//             fillOpacity: 0.35,
//             map,
//             center: { lat: marker.getPosition().lat(), lng: marker.getPosition().lng() },
//             radius: boundsDistance * 1000
//         })

//         marker.setAnimation(4)

//         // Reset all channelSegment visibleLocations count to 0
//         Object.keys(channelSegments).map((channelSegment) => {
//             return channelSegments[channelSegment].visibleLocations = 0
//         })

//         // Create a list of mapPins that are within the travelTimeBounds
//         const exportLocations = []
//         const areaBounds = travelTimeBounds.getBounds()
//         markers.map((marker, i) => {
//             if (areaBounds.contains(marker.getPosition()) === true) {
//                 const location = mapPins[i]
//                 if (channelSegments[location.channelSegment].isVisible) {
//                     channelSegments[location.channelSegment].visibleLocations++   
//                     exportLocations.push(location.id)
//                 }
//             }
//             else {
//                 // Can optionally set markers outside the bounds to a different color
//                 // marker.setIcon(icon({channelSegment: 'grey'}))
//             }
//             return null
//         })

//         setTravelTimeBounds(travelTimeBounds)
//         setExportLocations(exportLocations)
//         setChannelSegments(channelSegments)

//     }

//     // Show/hide all markers for a channel Segment
//     function toggleChannelSegment(channelSegment) {
//         channelSegments[channelSegment].isVisible = !channelSegments[channelSegment].isVisible

//         markers.map((marker, i) => {
//             return marker.setMap(channelSegments[mapPins[i].channelSegment].isVisible ? map : null)
//         })

//         setChannelSegments(channelSegments)

//     }

//     // console.log(mapPins)

//     // async function getLocations() {

//     //     const res = await fetch('http://localhost:4000/locations')
//     //     const reader = res.body
//     //     .getReader()
    
//     //     while (true) {
//     //         const { value, done } = await reader.read()
//     //         if (done) break
//     //         const res = utf8decoder.decode(value)
//     //         setLocations(locations => `${locations}${res}`)
//     //     }
        
//     // }

//     console.log('[TRAVELTIME DATA]:', travelTimeData)

//     return (

//         <Sidebar>

//             <Search 
//                 onChange={(id) => {
//                     const i = data.mapPins.findIndex(x => x.id === id)
//                     setSelectedMarker(i)
//                 }} 
//                 onSetGeometry={ geometry => {
//                     console.log(geometry.location)
//                     const google = window.google

//                     const marker = new google.maps.Marker({
//                         position: { lat: geometry.location.lat, lng: geometry.location.lng },
//                         map,
//                         // icon: icon(pin),
//                         // title: pin.companyName,
//                         // ...(pin.googlePlaceId && {
//                         //     place: {
//                         //         placeId: pin.googlePlaceId,
//                         //         location: { lat: parseFloat(pin.latitude), lng: parseFloat(pin.longitude) }
//                         //     }
//                         // })                    
//                     })

//                     map.panTo(marker.getPosition())
//                     map.setZoom(14)

//                 }}
//             />

//             {/* <FetchMore onRender={() => {
//                 if (data && data.mapPins.length < 200) {
//                     fetchMore({
//                         variables: {
//                             offset: mapPins.length
//                         },
//                         updateQuery: (prev, { fetchMoreResult }) => {
//                             if (!fetchMoreResult) return prev
//                             return Object.assign({}, prev, {
//                                 mapPins: [...prev.mapPins, fetchMoreResult.mapPins]
//                             })
//                         }
//                     })
//                 }
//             }} data={ data } /> */}

//             {/* <Card>
//                 <Search name='search' label='Search' />
//             </Card> */}

//             {
//                 selectedMarker ? (
//                     <Card>
//                         <Location 
//                             id={ mapPins[selectedMarker].id} 
//                             currentRadius={ boundsDistance } 
//                             selectRadius={ exportLocations.length > 0 ? true : false }
//                             onChangeRadius={ (radius) => changeBoundsDistance(radius) }
//                             onClick={ () => { getNearbyLocations() } }
//                         />
//                     </Card>
//                 ) : null
//             }

//             <Card>
//                 {
//                     // Show channelSegment filters
//                     Object.keys(channelSegments).map((channelSegment, i) => {

//                         const visibleLocations = exportLocations.length > 0 ? 
//                             channelSegments[channelSegment].visibleLocations 
//                         : 
//                             channelSegments[channelSegment].totalLocations

//                         // const { mapTypes } = channelSegments[channelSegment]

//                         return (
//                             <FilterItem key={channelSegment}>
//                                 <Toggle 
//                                     className={camelCase(channelSegment)}  
//                                     on={ channelSegments[channelSegment].isVisible } 
//                                     onChange={() => toggleChannelSegment(channelSegment)} 
//                                 />
//                                 <div className='filterItem__text'>{channelSegment} ({ visibleLocations })</div>
//                                 {/* <Expander>
//                                     {
//                                         mapTypes && mapTypes.map((type, i) => <div key={ i }>{ type }</div>)
//                                     }
//                                 </Expander> */}
//                             </FilterItem>
//                         )
//                     })
//                 }
//                 { exportLocations.length > 0 ? (
//                         <LocationData exportLocations={ exportLocations } />
//                     ) : null}
//             </Card>

//         </Sidebar>
//     )

// }

// function loadScript(url) {
//     var index = window.document.getElementsByTagName("script")[0]
//     var script = window.document.createElement("script")
//     script.src = url
//     script.async = true
//     script.defer = true
//     index.parentNode.insertBefore(script, index)
// }

// const headers = [
//     { label: "Aims ID", key: "id" },
//     { label: "Channel Segment", key: "channelSegment" },
//     { label: "Map Type", key: "mapType" },
//     { label: "Company Name", key: "companyName" },
//     { label: "Address", key: "address" },
//     { label: "Suite", key: "suiteNumber" },
//     { label: "City", key: "city" },
//     { label: "Province", key: "province" },
//     { label: "Postal", key: "postal" },
//     { label: "Phone", key: "phone" },
//     { label: "Contact Name", key: "contactName" },
//     { label: "Title", key: "title" },
//     { label: "Gender", key: "gender" },
//     { label: "Employment Size", key: "locationEmploymentSize" },
//     { label: "Credit Ratingg", key: "creditRating" },
//     { label: "Parts Potential", key: "partsPotential" },
//     { label: "Sales Volume", key: "locationSalesVolume" }
// ];

// function LocationData({ exportLocations }) {

//     const { error, loading, data } = useQuery(GET_LOCATION_DATA, { variables: { ids: exportLocations } })

//     if (loading) return null
//     if (error) return `Error! ${error.message}`

//     const locations = []
//     data.locations && data.locations.map(location => {
//         return locations.push({
//             ...location,
//             phone: `="${ location.phone }"`,
//             locationEmploymentSize: `="${ location.locationEmploymentSize }"`,
//             partsPotential: `="${ location.partsPotential || '' }"`,
//             locationSalesVolume: `="${ location.locationSalesVolume.replace(",","") }"`
//         })
//     })

//     return <CSVLink data={locations} headers={headers} enclosingCharacter={``} filename={"AIMS_Data.csv"}><button className="export-btn">Export Records ({ exportLocations.length })</button></CSVLink>
// }

// function FetchMore({ data, onRender }) {
//     useEffect(() => {
//         onRender()
//     }, [data, onRender])

//     return null
// }